import validateVar from "./validation/validateVariable";
import {emptyValue} from "./global";

function getIdentifierName(market_identifier, meter_identifier) {
    if(validateVar(market_identifier)) return 'MaLo-ID';
    else if(validateVar(meter_identifier)) return 'Zählpunkt';
    else return emptyValue;
}

export default getIdentifierName;